import { InputBase, makeStyles, Theme } from '@material-ui/core';
import React, { ChangeEvent, useRef, useEffect } from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  hiddenSpan: {
    position: 'absolute',
    visibility: 'hidden',
    whiteSpace: 'pre',
    fontSize: theme.typography.body1.fontSize,
    fontFamily: theme.typography.fontFamily,
    top: 0,
    left: 0,
  },
  input: {
    paddingLeft: theme.spacing(0.5),
    fontSize: theme.typography.body1.fontSize,
  },
}));

interface AutosizeInputProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder: string;
  className?: string;
}
export const AutosizeInput: React.FC<AutosizeInputProps> = ({
  value,
  onChange,
  placeholder,
  className,
}) => {
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);
  const hiddenSpanRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (hiddenSpanRef.current && inputRef.current) {
        const padding = 30;
        const minWidth = 50;
        const maxWidth = 400;

        const contentWidth = hiddenSpanRef.current.offsetWidth;
        const targetWidth = Math.max(minWidth, Math.min(contentWidth + padding, maxWidth));

        const currentWidth = inputRef.current.clientWidth;
        if (Math.abs(currentWidth - targetWidth) > 5) {
          inputRef.current.style.width = `${targetWidth}px`;
        }
      }
    }, 50);

    return () => clearTimeout(debounceTimer);
  }, [value]);

  return (
    <>
      <InputBase
        ref={inputRef}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${classes.input} ${className}`}
      />
      <span ref={hiddenSpanRef} className={classes.hiddenSpan}>
        {value || placeholder}
      </span>
    </>
  );
};
